import { Input } from '@/components/ui/input';
import type { DefaultFormControlProps } from '@/pages/WorkflowsCatalog/components/run/controls/types';
import type { FieldValues } from 'react-hook-form';

const DefaultFormControl = <T extends FieldValues>({
  field,
  propertyType,
}: DefaultFormControlProps<T>) => {
  return (
    <Input
      {...field}
      type={propertyType}
      value={field.value as string}
      onChange={(e) => {
        const v = e.target.value;
        if (propertyType === 'number') field.onChange(v === '' ? '' : Number(v));
        else field.onChange(v);
      }}
    />
  );
};

export default DefaultFormControl;
